import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import { Prop } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "DeviceDocumentActionMenu" })
export default class DeviceDocumentActions extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public validationErrors: any[] = [];

    get routes() {
        return (<any>window).App.routes;
    }

    @Prop() readonly deviceSerialNumber: string;
    @Prop() readonly documentCode: string;
    @Prop() readonly documentType: string;

    public async sendToDevice() {
        this.validationErrors = [];
        this.isLoading = true;

        try {
            let result = (await Axios.post(this.routes.MyMectronicDevice_SendDocumentToDevice, { code: this.documentCode, serialNumber: this.deviceSerialNumber }, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;

            GTagHelper.sendEvent("click", "firmware_update");

            this.$store.dispatch("app-toastStore/onAddToast", { message: this.localizer.get("MyMectronic.Common.FirmwareUpdate_SendToDevice_Success"), type: "Success" });
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }

            this.$store.dispatch("app-toastStore/onAddToast", { message: this.localizer.get("MyMectronic.Common.FirmwareUpdate_SendToDevice_Error"), type: "Error" });
        }

        this.isLoading = false;
    }

    public confirmSendToDevice() {
        var result = confirm(this.localizer.get("MyMectronic.Common.FirmwareUpdate_SendToDevice_Alert"));
        if (result) {
            this.sendToDevice();
        }
    }
};